import React from "react"
import PropTypes from "prop-types"
import {Box, Paper, Typography} from "@mui/material"
import ButtonWithIcon from "src/v2/components/Button/Button"
import {ReactComponent as FileIcon} from "src/v2/assets/icons/file-icon.svg"
import {ReactComponent as SaveIcon} from "src/v2/assets/icons/download-cloud-icon.svg"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import ValidationResultsLayout from "./validation-results-layout"
import {
    CALCULATION_STATUS,
    normalizedValidationPremiosPropType,
    validationResultsPropType,
} from "./validation-contract"
import {
    getValidationResultGroups,
} from "./validation-results-model"

const EMPTY_RESULTS_MESSAGE = "Preencha os parâmetros e calcule para visualizar os resultados."
const RESULT_ACTIONS = [
    {
        label: "Exportar CSV",
        icon: <FileIcon aria-hidden="true"/>,
        callbackName: "onExport",
    },
    {
        label: "Salvar spread e prazo da emissão",
        icon: <SaveIcon aria-hidden="true"/>,
        callbackName: "onSaveEmission",
    },
    {
        label: "Salvar validação",
        icon: <CheckIcon aria-hidden="true"/>,
        callbackName: "onSaveValidation",
    },
]

const ValidationResultsSection = ({
    calculationStatus,
    results,
    premios,
    onExport,
    onSaveEmission,
    onSaveValidation,
}) => {
    const resultActionCallbacks = {
        onExport,
        onSaveEmission,
        onSaveValidation,
    }
    const resultGroups = getValidationResultGroups(results, premios)

    return (
        <Paper
            component="section"
            elevation={0}
            aria-labelledby="validation-result-title"
            sx={{
                mt: 3,
                p: {xxxs: 2, md: 3},
                bgcolor: "background.paper",
                borderRadius: 0,
            }}
        >
            <Box
                component="header"
                sx={{
                    display: "flex",
                    flexDirection: {xxxs: "column", lg: "row"},
                    alignItems: {xxxs: "flex-start", lg: "center"},
                    justifyContent: "space-between",
                    gap: 2,
                }}
            >
                <Box>
                    <Typography id="validation-result-title" variant="h5" sx={{color: "common.white"}}>
                        Resultado
                    </Typography>
                    {calculationStatus === CALCULATION_STATUS.IDLE && (
                        <Typography variant="textBody" sx={{display: "block", mt: 0.5, color: "primary.white70"}}>
                            {EMPTY_RESULTS_MESSAGE}
                        </Typography>
                    )}
                    {calculationStatus === CALCULATION_STATUS.LOADING && (
                        <Typography role="status" variant="textBody" sx={{display: "block", mt: 0.5, color: "primary.white70"}}>
                            Calculando resultados...
                        </Typography>
                    )}
                </Box>

                <Box
                    aria-label="Ações do resultado"
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: {xxxs: "flex-start", lg: "flex-end"},
                        gap: 2,
                    }}
                >
                    {RESULT_ACTIONS.map(({label, icon, callbackName}) => {
                        const callback = resultActionCallbacks[callbackName]

                        return (
                            <ButtonWithIcon
                                key={label}
                                size="md"
                                icon={icon}
                                disabled={!callback}
                                onClick={callback}
                            >
                                {label}
                            </ButtonWithIcon>
                        )
                    })}
                </Box>
            </Box>

            <Box sx={{mt: 2}}>
                <ValidationResultsLayout groups={resultGroups}/>
            </Box>
        </Paper>
    )
}

ValidationResultsSection.propTypes = {
    calculationStatus: PropTypes.oneOf(Object.values(CALCULATION_STATUS)).isRequired,
    results: validationResultsPropType.isRequired,
    premios: normalizedValidationPremiosPropType.isRequired,
    onExport: PropTypes.func,
    onSaveEmission: PropTypes.func,
    onSaveValidation: PropTypes.func,
}

export default ValidationResultsSection
